import React from 'react'
import { TrimText } from '../common/TrimText';
import { useDispatch } from 'react-redux';
import SkeletonContainer, { getSkeletonHeight } from '../../loaders/SekletonContainer';
import { updateActivityBtnAction } from '../../store/actions';
import { BodySmall, Heading4, Heading5, LabelSmallBold, LabelText } from '../common/GlobalElements/Typography';
import { Card } from '../common/GlobalElements/Card';
import { tokens } from '../../public/tokens';

function AssemblyItemBox({ assemblies, setModuleId, setshow, setLearningTab,  setAssemblyCategoryList,loading,setLessonList}) {
    const dispatch = useDispatch();
    const handleAssemblyClick = (ele) => {
        dispatch(updateActivityBtnAction('continue'))
        setshow({ cards: false, list: true, desc: true })
        setLessonList(ele)
        setLearningTab(true)
         setAssemblyCategoryList(ele)
        for (let i = 0; i < ele?.assembliesItems?.length; i++) {
            const currentItem = ele.assembliesItems[i];
    
            if (currentItem?.lessons?.length) {
                setModuleId(currentItem?.item_id); 
                break;
            }
        }
    }
    return (
        <>
            {loading && <SkeletonContainer height={getSkeletonHeight(30)} />}
            {!loading && assemblies?.length > 0 ? (<div className="">
                <Heading4 className='text-primary mb-2 pt-3'>Learning Material Overview</Heading4>
                <div className='row flex-direction-column assemblies-list-container'>
                    {assemblies?.map((ele, i) => {
                        return (
                            <div    
                                className="col-lg-6 col-md-6 col-xs-12 card-wrapper mb-3"
                                key={ele.id}
                                title={ele.name}
                                onClick={() => handleAssemblyClick(ele)}
                            >
                                <Card>
                                    <div className={`assembly-card-content card-content ${ele?.subjectStatus === "Not Yet Published" ? " disabled" : "" }`}>
                                        <div>
                                            <Heading5 className='text-primary text-left mb-1' title={ele.name || "NA"} style={{ padding: "0" }}>
                                                {ele.name ? TrimText(ele.name, 50) : "NA"}
                                            </Heading5>
                                            <LabelText as="p" className="text-secondary text-left mb-2 mt-1" title={new DOMParser().parseFromString(ele.item_description,"text/html").body.textContent || "NA"}>
                                                {ele?.item_description
                                                    ? ele.item_description !== ""
                                                        ? TrimText(
                                                            new DOMParser().parseFromString(ele.item_description, "text/html").body.textContent.replace(/\s+/g, ' ').trim() || "NA",
                                                            150
                                                        )
                                                        : "NA"
                                                    : "NA"}
                                            </LabelText>
                                        </div>
                                        <div className="text-left mt-1">
                                            <div className="progress-program progress-statistics">
                                                <div className="program-stats w-100 text-left">
                                                    <LabelSmallBold as="span" className="text-theme-topbar p-0 mb-1" title="progress">
                                                        {ele?.completedPercentage || "0"}% completed
                                                    </LabelSmallBold>
                                                    <div className="progress progress-bar-wrapper mt-1">
                                                        <div
                                                            className="progress-bar progress-tiny-text zero-progress"
                                                            role="progressbar"
                                                            style={{
                                                                width: (ele?.completedPercentage || 5) + "%",
                                                            }}
                                                            aria-valuenow="25"
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                            title="progress"
                                                        >
                                                            {ele?.completedPercentage}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="program-statistics-count-2 mt-2" >
                                                <ul className="num-info d-flex pl-0 text-left mb-0">
                                                    {ele?.assembliesTotalVideos > 0 && (
                                                        <li title="Videos" className="videoes">
                                                            <i className="fal fa-video" />
                                                            <span className="value">
                                                                {ele?.assembliesTotalVideos}
                                                            </span>
                                                        </li>
                                                    )}
                                                    {ele?.assembliesTotalQuiz > 0 && (
                                                        <li title="Quizzes" className="Quizzes">
                                                            <i className="fal fa-clipboard-list" />
                                                            <span className="value">
                                                                {ele?.assembliesTotalQuiz}
                                                            </span>
                                                        </li>
                                                    )}
                                                    {ele?.assembliesTotalDocuments > 0 && (
                                                        <li title="Files" className="files">
                                                            <i className="fal fa-file" />
                                                            <span className="value">
                                                                {ele?.assembliesTotalDocuments}
                                                            </span>
                                                        </li>
                                                    )}
                                                    {ele.progress?.total_assessment > 0 && (
                                                        <li
                                                            title="Assessment"
                                                            className="files"
                                                        >
                                                            <i className="fal fa-ballot" />
                                                            <span className="value">
                                                                {ele.progress?.total_assessment}
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        );
                    })}
                </div>
            </div>) : !loading &&
            <div
                className="no__content__section"
                id="accordion"
                role="tablist"
                aria-multiselectable="true"
            >
                <div className="subject-header p-0" >
                    <BodySmall fontWeight={tokens.typography.fontWeights.bold} className='text-theme-topbar'>No Content Available.</BodySmall>
                </div>
            </div>}
        </>
    )
}

export default AssemblyItemBox
